import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5678dfaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "orcamento",
  class: "main-simulador"
}
const _hoisted_2 = { class: "container-site" }
const _hoisted_3 = { class: "cartao-simulador" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "coluna-chamada" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "rotulo-secao rotulo-amarelo" }, " Simulador "),
  /*#__PURE__*/_createElementVNode("h2", { class: "titulo-secao" }, " Quanto dá para economizar com energia solar? "),
  /*#__PURE__*/_createElementVNode("p", { class: "texto-chamada" }, " Digite o valor da sua conta de luz e veja uma estimativa na hora. Depois é só pedir a simulação completa, sem compromisso. ")
], -1))
const _hoisted_5 = { class: "coluna-calculo" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "rotulo-campo",
  for: "conta-luz"
}, " Sua conta de luz por mês ", -1))
const _hoisted_7 = { class: "campo-valor" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prefixo" }, " R$ ", -1))
const _hoisted_9 = { class: "valores-rapidos" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "resultados"
}
const _hoisted_12 = { class: "resultado" }
const _hoisted_13 = { class: "valor-resultado" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legenda-resultado" }, " por mês ", -1))
const _hoisted_15 = { class: "resultado" }
const _hoisted_16 = { class: "valor-resultado" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legenda-resultado" }, " por ano ", -1))
const _hoisted_18 = { class: "resultado" }
const _hoisted_19 = { class: "valor-resultado" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legenda-resultado" }, " em 25 anos ", -1))
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "20",
  height: "20",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 20l1.2-5.1A8.5 8.5 0 1 1 21 11.5z" })
], -1))
const _hoisted_23 = { class: "aviso-simulador" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              id: "conta-luz",
              type: "number",
              inputmode: "numeric",
              min: "0",
              step: "50",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.conta) = $event)),
              placeholder: "500"
            }, null, 512), [
              [
                _vModelText,
                _ctx.conta,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([300, 500, 1000], (valor) => {
              return _createElementVNode("button", {
                key: valor,
                class: _normalizeClass(["chip-valor", { 'chip-ativo': _ctx.conta === valor }]),
                onClick: ($event: any) => (_ctx.conta = valor)
              }, " R$ " + _toDisplayString(valor), 11, _hoisted_10)
            }), 64))
          ]),
          (_ctx.contaValida)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formatar(_ctx.economiaMensal)), 1),
                  _hoisted_14
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatar(_ctx.economiaMensal * 12)), 1),
                  _hoisted_17
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.formatar(_ctx.economiaMensal * 12 * 25)), 1),
                  _hoisted_20
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "botao-pilula botao-simular",
            disabled: !_ctx.contaValida,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pedirSimulacao()))
          }, [
            _createTextVNode(" Receber simulação completa "),
            _hoisted_22
          ], 8, _hoisted_21),
          _createElementVNode("p", _hoisted_23, " Estimativa com economia de até " + _toDisplayString(_ctx.PERCENTUAL_ECONOMIA * 100) + "% da conta. O valor real depende do projeto e do local. ", 1)
        ])
      ])
    ])
  ]))
}